import { takeLatest, takeEvery, all } from 'redux-saga/effects';
// import FixtureAPI from '../Services/FixtureApi'

// Redux types
import { SearchTypes } from '../Redux/Search';
import { FullSearchTypes } from '../Redux/FullSearch';
import { NewsLetterTypes } from '../Redux/NewsLetter';

// saga
import { getSearchResult, getSearchCatalogResult } from "./Search";
import { getFullSearchResult } from "./FullSearch";


import { trySendEmail } from "./NewsLetter";

// API
// search
import SearchAPI from '../Services/Search';

const search_api = SearchAPI.create();

// full search
import FullSearchAPI from '../Services/FullSearch';

const full_search_api = FullSearchAPI.create();

// NewsAPI
import NewsAPI from '../Services/NewsLetter';

const news_api = NewsAPI.create();


/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
    yield all([
        // search
        takeLatest(SearchTypes.SEARCH, getSearchResult, search_api),
        takeLatest(SearchTypes.CHANGE_TAG, getSearchCatalogResult, search_api),
        takeLatest(SearchTypes.SEARCH_CATALOG, getSearchCatalogResult, search_api),
        // full search
        takeLatest(FullSearchTypes.FULL_SEARCH, getFullSearchResult, full_search_api),
        takeLatest(FullSearchTypes.CHANGE_ACTIVED_TYPE, getFullSearchResult, full_search_api),
        takeLatest(FullSearchTypes.CHANGE_SEARCH_PAGE_NUM, getFullSearchResult, full_search_api),
        // email
        takeLatest(NewsLetterTypes.SEND_EMAIL, trySendEmail, news_api)
    ]);
}
